import React from 'react';
import SpaceConfigurationsConfigProvider from '../data/spaceconfigurationsconfig-hooks';
import SpaceConfigurations from '../components/SpaceConfigurations';

function SpaceConfigurationsApp(props) {

    const templateContainerID = props.templateContainerID;
    const configContainerID = props.configContainerID;

    return (
        <div className="spacesConifgurations">
            <SpaceConfigurationsConfigProvider templateContainerID={templateContainerID} configContainerID={configContainerID}>
                <SpaceConfigurations></SpaceConfigurations>
            </SpaceConfigurationsConfigProvider>
        </div>
    );
}

export default SpaceConfigurationsApp;